"use strict";

exports.__esModule = true;
exports.NumericEditor = exports.EDITOR_TYPE = void 0;
var _numericEditor = require("./numericEditor");
exports.EDITOR_TYPE = _numericEditor.EDITOR_TYPE;
exports.NumericEditor = _numericEditor.NumericEditor;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/numericEditor/index.js
// module id = 447
// module chunks = 0